import { RAI_SSO_SERVICE_URL } from "../definitions.js"
/* import { apiCall, responseValidation } from '../utils.js'; */
import { apiCall } from '../utils.js';
import { LoginResponseLogin } from "./service-models.js"
/* import { loginResponseLoginSchema } from "./utils.js" */
import { RaissoError, errorFactory } from "../responses.js"
import { R } from "@mobily/ts-belt"

const BASE_URL = `${RAI_SSO_SERVICE_URL}/login`

export { BASE_URL as LOGIN_BASE_URL }

function traceError(e: unknown) {
  console.error('[login-controller] Error:', e)
}

class LoginController {
  private constructor() {/* empty */}

  private static _instance: LoginController
  public static get instance(): LoginController {
    if (!this._instance) {
      this._instance = new LoginController()
    }
    return this._instance
  }

  public async social(data: string) {
    const url = `${BASE_URL}/social`
    try {
      const response = await apiCall<LoginResponseLogin>(url, 'json', 'POST', { 'content-type': 'application/json' }, data)
      /* const value = R.map(response, responseValidation(loginResponseLoginSchema)) */
      return response;
    } catch (e) {
      traceError(e)
      return R.Error<RaissoError>(errorFactory(
        RaissoError,
        (e instanceof Error) ? e.message : 'Opps! Qualcosa è andato storto',
        { cause: e, context: { request: { url, body: data } } }
      ))
    }
  }

  public async site(domainApiKey: string, email: string, password: string, appId?: string, ente?: boolean) {
    const url = `${BASE_URL}/site`
    const body = new URLSearchParams({
      domainApiKey,
      email, password
    })
    if (appId) {
      body.set('appId', appId)
    }
    if (ente) {
      body.set('ente', `${ente}`)
    }
    try {
      const response = await apiCall<LoginResponseLogin>(url, 'json', 'POST', { 'content-type': 'application/x-www-form-urlencoded' }, body.toString())
      /* const value = R.map(response, responseValidation(loginResponseLoginSchema)) */
      return response;
    } catch (e) {
      traceError(e)
      return R.Error<RaissoError>(errorFactory(
        RaissoError,
        (e instanceof Error) ? e.message : 'Opps! Qualcosa è andato storto',
        { cause: e, context: { request: { url, body: body.toString() } } }
      ))
    }
  }
}

export default LoginController
